/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useEmployeeService } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';

export const EMPLOYEE_CONTEXT = 'Employee';

const EmployeeContext = ({ permissionToCheck, children, idSource, id }: SecurityContextCommonProps) => {
  const { getCombinedFromServicesEmployeePermissions } = useEmployeeService();
  const currentAlias = useEmployeeId() || id || '';

  return (
    <SecurityContextTemplate
      getPermissionsFunc={() => getCombinedFromServicesEmployeePermissions(currentAlias)}
      permissionToCheck={permissionToCheck}
      id={currentAlias}
      idSource={idSource}
      contextName={EMPLOYEE_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default EmployeeContext;
